function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_174",
  "data-name": "Group 174",
  transform: "translate(0.504 0.529)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_245",
  "data-name": "Path 245",
  d: "M668.4,225.594a10,10,0,1,1-.511,2.269",
  transform: "translate(-667.83 -218.908)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_173",
  "data-name": "Group 173",
  transform: "translate(4.961 6.441)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y1: 1.082,
  x2: 1.082,
  transform: "translate(8.997)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_246",
  "data-name": "Path 246",
  d: "M672.486,228.561l3.324,3.617,4.493-4.814",
  transform: "translate(-672.486 -225.043)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoCheckmark = function SvgJoratoCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.033,
    height: 21.061,
    viewBox: "0 0 21.033 21.061",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-checkmark.9dd99bcc.svg";
export { ForwardRef as ReactComponent };